import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Whychoosenlp() {
  return (
    <section className="rapid_free_services p-100 tekrevol_dark_bg nlp_why_choose">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">
              Why Choose TekRevol for <span>NLP Solutions Development?</span>
            </h3>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Contact Us
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              TekRevol is your trusted partner for NLP development, delivering
              precise, impactful solutions that empower you against new-age
              business challenges. Our expertise and innovative approach ensure
              that your business gains a competitive edge through efficient and
              scalable NLP implementations.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-4 mt-md-5">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                01
              </div>
              <div className="rapid_content">
                <h5>Experienced NLP Engineers</h5>
                <p>
                  Our team comprises highly skilled NLP engineers who specialize
                  in creating advanced solutions tailored to your specific
                  business needs.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                02
              </div>
              <div className="rapid_content">
                <h5>Customized Implementations</h5>
                <p>
                  We design and implement NLP solutions that align perfectly
                  with your operational requirements, ensuring seamless
                  integration and optimal performance.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                03
              </div>
              <div className="rapid_content">
                <h5>Cost-Efficient Automation</h5>
                <p>
                  Reduce operational costs through intelligent automation of
                  data processing tasks, increasing overall efficiency and
                  productivity.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                04
              </div>
              <div className="rapid_content">
                <h5>Scalable Architectures</h5>
                <p>
                  Our NLP solutions are built on scalable architectures,
                  enabling your business to expand effortlessly and handle
                  increasing data volumes.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                05
              </div>
              <div className="rapid_content">
                <h5>Comprehensive Data Security</h5>
                <p>
                  Implement comprehensive security measures to protect sensitive
                  data and maintain compliance with industry regulations.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                06
              </div>
              <div className="rapid_content">
                <h5>Continuous Model Training</h5>
                <p>
                  Take advantage of continuous model training and updates,
                  ensuring that your NLP solutions remain accurate and effective
                  over time.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosenlp;
